import packageJson from '../../package.json';

export const environment = {
  production: false,
  apiUrl: 'https://stbstaffingdevapi.clearlyagile.com', // API URL for development environment
  appVersion: packageJson.version,
  msal: {
    apiClientId: '264d2b7f-7c23-4467-8f89-2a09d0afe701', // Development environment Azure AD app client ID
    uiClientId: 'f779ce4f-1322-49a1-aabc-8a82de2e8543', // Development environment Azure AD app client ID
    authority:
      'https://login.microsoftonline.com/fa5528cd-3a0e-4fa1-9de2-cb695912ec06', // Tenant ID
    redirectUri: 'https://stbstaffingdevui.clearlyagile.com/redirect', // Redirect URI Development environment domain
  },
};
